import { WindowLocationService } from '@propertyfinder/pf-frontend-common/src/service/window-location/service';

import { ContentGroupStrategyTab } from 'common/module/content-group/strategy/tab';

import { ContentGroupStrategyInterface } from '../strategy.interface';

export function ContentGroupStrategyTabFactory(): ContentGroupStrategyInterface {
  return new ContentGroupStrategyTab(WindowLocationService());
}
